import { useState, useEffect, useCallback } from 'react';

export type LanguageConfig = {
  id: string;
  label: string;
};

/**
 * Hook for filtering languages by search term
 */
export function useLanguageFilter(languageList: LanguageConfig[]) {
  const [filteredList, setFilteredList] = useState<LanguageConfig[]>(languageList);
  const [filter, setFilterState] = useState('');

  useEffect(() => {
    setFilteredList(languageList);
    setFilterState('');
  }, [languageList]);

  const setFilter = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setFilterState(value);
      
      if (value.trim() === '') {
        setFilteredList(languageList);
      } else {
        const searchTerm = value.toLowerCase();
        const filtered = languageList.filter(({ label, id }) =>
          label.toLowerCase().includes(searchTerm) ||
          id.toLowerCase().includes(searchTerm)
        );
        setFilteredList(filtered);
      }
    },
    [languageList]
  );

  return { filter, setFilter, filteredList };
}


